
import { BannerSize } from '@/types/banner';
import { BannerTemplate, BannerTemplateFormat } from '@/types/bannerTemplate';
import { TEMPLATE_SETS } from './mockData';

/**
 * Get all template sets
 */
export const getTemplateSets = () => {
  return TEMPLATE_SETS;
};

/**
 * Get a template set by ID
 */
export const getTemplateSet = (id: string) => {
  return TEMPLATE_SETS.find(set => set.id === id);
};

/**
 * Get a template by ID
 */
export const getTemplate = (id: string): BannerTemplate | undefined => {
  for (const set of TEMPLATE_SETS) {
    const template = set.templates.find(t => t.id === id);
    if (template) return template;
  }
  return undefined;
};

/**
 * Get a template format by template ID and size
 */
export const getTemplateFormat = (templateId: string, size: BannerSize): BannerTemplateFormat | undefined => {
  const template = getTemplate(templateId);
  if (!template) return undefined;
  
  return template.formats.find(f => f.size === size);
};
